const Util = {

    isObjectId(objectId: string): boolean {
        return !this.isEmpty(objectId) && objectId.length === 24;
    },

    isEmpty(word: string): boolean {
        return !word || 0 === word.length || !word.trim();
    },

    scrollToElementWithId(id: string): void {
        const element = document.getElementById(id);
        if (element != null) {
            const position = element.offsetTop;
            window.scrollTo({ top: position, behavior: 'smooth' });
        }
    },

    validateEmail(email: string): boolean {
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    },

    saveFile(content: string, fileName: string, contentType: string) {
        const a = document.createElement('a');
        const file = new Blob([content], {type: contentType});
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    },

    updateHeaders(title: string, description: string, image: string): void {
        if (!this.isEmpty(title)) {
            document.title = `${title} | Moominhouse`;
            this.removeElementsWithAttribute('vue-controlled-title');
            this.addMetaTagToHead(new Map<string, string>()
                .set('content', `${title} | Moominhouse`)
                .set('vue-controlled-title', '')
                .set('property', 'og:title'));
        }

        if (!this.isEmpty(description)) {
            this.removeElementsWithAttribute('vue-controlled-description');
            const map = new Map<string, string>()
                .set('content', description)
                .set('vue-controlled-description', '');
            this.addMetaTagToHead(new Map<string, string>(map).set('name', 'description'));
            this.addMetaTagToHead(map.set('property', 'og:description'));
        }

        if (!this.isEmpty(image)) {
            this.removeElementsWithAttribute('vue-controlled-image');
            const map = new Map<string, string>()
                .set('content', image)
                .set('vue-controlled-image', '');
            this.addMetaTagToHead(new Map<string, string>(map).set('name', 'image'));
            this.addMetaTagToHead(map.set('property', 'og:image'));
        }

        if (!document.body.classList.contains('pre-render-ready')) {
			document.body.classList.toggle('pre-render-ready');
		}
    },

    addMetaTagToHead(map: Map<string, string>): void {
        document.head.appendChild(this.createTagWithAttributes('meta', map));
    },

    createTagWithAttributes(tagName: string, keyValue: Map<string, string>): HTMLElement {
        const tag = document.createElement(tagName);
        for (const [key, value] of keyValue) {
            tag.setAttribute(key, value);
        }
        return tag;
    },

    removeElementsWithAttribute(attribute: string): void {
        Array.from(document.querySelectorAll('[' + attribute + ']')).map((element: Element) => {
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        });
    }
};

export default Util;
